import { FactureFournisseurDTO, StatusFacture } from '@/models/FactureFournisseurDTO';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';

export interface FactureFournisseurState {
    factures: FactureFournisseurDTO[];

    filtreOperateur?: string;
    filtreMontant?: number;
    filtreSociete?: string;
    filtreNumerofacture?: string;
    filtreEtat?: StatusFacture[];
    filtreDateDebut?: string;
    filtreDateFin?: string;

    isLoading: boolean;
    isXlsLoading: boolean;

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };
    tableHeader: TableHeader[];
    page: number;
    numberOfPage: number;
    scroll: number;
    count: number;
}

export const initialState: FactureFournisseurState = {
    factures: [],

    isLoading: false,
    isXlsLoading: false,

    tableHeader: [
        {
            label: 'idMasquee',
            sortData: 'idMasquee',
            sortStatus: SortType.NONE,
            width: '0%',
        },
        {
            label: 'facture.fournisseur.data.societe',
            sortData: 'societe',
            sortStatus: SortType.NONE,
            width: '15%',
        },
        {
            label: 'facture.fournisseur.data.fournisseur',
            sortData: 'site',
            sortStatus: SortType.NONE,
            width: '15%',
        },
        {
            label: 'facture.fournisseur.data.date',
            sortData: 'date',
            sortStatus: SortType.DESC,
            width: '5%',
        },
        {
            label: 'facture.fournisseur.data.numero',
            sortData: 'numero',
            sortStatus: SortType.NONE,
            width: '5%',
        },
        {
            label: 'facture.fournisseur.data.echeance',
            sortData: 'echeance',
            sortStatus: SortType.NONE,
            width: '5%',
        },
        {
            label: 'facture.fournisseur.data.montant',
            sortData: 'montant',
            sortStatus: SortType.NONE,
            width: '8%',
        },
        {
            label: 'facture.fournisseur.data.solde',
            sortData: 'solde',
            sortStatus: SortType.NONE,
            width: '8%',
        },
        {
            label: 'facture.fournisseur.data.reglement',
            sortData: 'reglements.dateReglement',
            sortStatus: SortType.NONE,
            width: '5%',
        },
        {
            label: 'facture.fournisseur.data.type',
            sortData: 'typeFacture',
            sortStatus: SortType.NONE,
            width: '5%',
        },
        {
            label: '',
            sortData: 'statut',
            sortStatus: SortType.NONE,
            width: '7%',
        }
    ],
    page: 0,
    numberOfPage: 0,
    scroll: 0,
    count: 0,
};

export const state: FactureFournisseurState = {
    ...initialState
};
